import * as React from 'react';
import { JSX } from 'react/jsx-runtime';

const LogoutIcon = (
    props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => (
    <svg
        viewBox="0 0 15 15"
        fill="none"
        width={'24px'}
        height={'24px'}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M13.5 7.5L10.5 10.75M13.5 7.5L10.5 4.5M13.5 7.5L4 7.5M8 13.5H1.5L1.5 1.5L8 1.5"
            stroke="currentColor"
        />
    </svg>
);
export default LogoutIcon;
